<template>
    <!-- 组件用于对请求的数据进行滚动分页加载 -->
    <mt-loadmore
        :bottom-method="getMore" 
        :bottom-all-loaded="allLoaded"
        :auto-fill="false"
        :topDistance=0
        ref="loadmore">
        <slot :data="result"/>
    </mt-loadmore>    
</template>

<script>
import global from '@/util/globalVar'
import { Indicator, Toast, Loadmore } from 'mint-ui'
import { debug } from 'util'
    export default {
        data () {
            return {                                           
                allLoaded: false,
                genLoader: null,
                result: [],
                storeTagPoints: [],                                 // 列表项dom中的top位置，用于每次滚动到标题位置
            }
        },
        props: {
            list: {
                type: Array,
                required: true,
            },
            onlyFetchOnce: {
                type: Boolean,
                default: true
            },
            page: { // 每次显示记录数
                type: Number || String,
                default: 8
            }
        },
        components: {
            'mt-loadmore': Loadmore,
        },
        methods: {
            getMore () {
                if (!this.genLoader) return 
                const { done, value:lst } = this.genLoader.next()
                if (done) {
                    this.allLoaded = true
                } else {
                    this.result = [...this.result, ...lst]
                }
                this.$refs.loadmore.onBottomLoaded();
            },
            * genLoadMore ({ data = [], size = this.$props.page }) {
                const total = Math.ceil(data.length/size)
                for (let i=0; i<total; i++) 
                    yield data.length>0 && data.slice(i*size, (i+1)*size)
            },
            saveStorePoints () {
                this.$nextTick(function() {                            // 保存滚动至列表项的头部的位置
                    var tags = document.querySelectorAll('.store-list ul li')
                    this.storeTagPoints = [...tags].map(item => item.offsetTop)
                })
            },  
        },
        watch: {
            'list' (data) {
                this.result = []
                this.genLoader =  this.genLoadMore({data})
                this.getMore()                                          // 首次加载数据
                this.allLoaded = false
                this.$nextTick(function() {                             // 列表滚动至头部
                    const el = this.$refs.loadmore.$el
                    el.parentNode.scrollTop = 0
                })
                                               
            }
        },
        created () {
            this.saveStorePoints()
        }
    }
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/store/components/load-more/index.vue